import { useEffect, useState } from "react";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { config } from "../CommonUtils/CommonURLS";
import { commonColumn, serialNumberColumn } from "../CommonUtils/CommunColumns";
import { FaEdit } from "react-icons/fa";
import { BiTrash } from "react-icons/bi";


export default function DesignationMaster() {
  const [desigTableData, setDesigTableData] = useState([]);
  const [serviceId, setServiceId] = useState(null);

  // Validation
  const validationSchema = Yup.object({
    designationName: Yup.string().required(ERROR_MSG).nullable(),
  });

  //  Formik
  const designationFormik = useFormik({
    initialValues: {
      designationName: "",
    },
    validationSchema,
    onSubmit: (val) => {
      Swal.fire({
        text: serviceId !== null ? "Are you sure you want to Update?" : "Are you sure you want to submit?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: serviceId !== null ?"Yes Update!": "Yes Submit!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let url = "";
          let payload = {};

          // EDIT MODE → Update API (desgId required in request body)
          if (serviceId !== null) {
            url = config.url.FAC_URL + "updateDesignation";
            payload = {
              desgId: serviceId,
              postDesc: val.designationName,
            };
          }
          // NEW → Save API
          else {
            url = config.url.FAC_URL + "saveDesignation";
            payload = {
              postDesc: val.designationName,
            };
          }

          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.status === true || res?.data?.scode === "01") {
                successAlert2( serviceId !== null ? "Updated Successfully": "Saved Successfully");
                designationFormik.resetForm();
                setServiceId(null);
                GetDesignationTableDetails();
              } else {
                failureAlert(res?.data?.sdesc || "Operation failed");
              }
            })
            .catch((error) => {
              console.error("API Error:", error);
              failureAlert("An error occurred while submitting the data.");
            });
        }
      });
    },
  });

  // Get Designations
  function GetDesignationTableDetails() {
    const url = config.url.FAC_URL + "getnonteachingdesig";
    CommonAxiosGet(url) .then((response) => {
        if (response?.data?.status === true) {
          setDesigTableData(response?.data?.data);
        } else {
          setDesigTableData([]);
        }
      })
      .catch(() => setDesigTableData([]));
  }

  // Delete — query param is `desId`
  function handleDelete(desgId) {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const url = config.url.FAC_URL + "deleteDesignation?desId=" + desgId;
        CommonAxiosPost(url)
          .then((response) => {
            if (response?.data?.status === true || response?.data?.scode === "01") {
              successAlert2(response?.data?.sdesc || "Deleted successfully");
              GetDesignationTableDetails();
            } else {
              failureAlert(response?.data?.sdesc || "Delete failed");
            }
          })
          .catch((error) => {
            console.error("Delete API Error:", error);
            failureAlert("An error occurred while deleting");
          });
      }
    });
  }

  // Edit — fill form + store desgId
  const handleEdit = (rowData) => {
    designationFormik.setValues({ designationName: rowData.post_desc });
    setServiceId(rowData.desg_id);
    setTimeout(() => {
      document.getElementById("service-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  useEffect(() => {
    GetDesignationTableDetails();
  }, []);

  const desigTableColumns = [
    serialNumberColumn,
    commonColumn("Designation ID", "desg_id", false, "center"),
    commonColumn("Designation Name", "post_desc", false, "left"),
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="d-flex gap-2 justify-content-center">
            <button type="button" className="btn btn-sm btn-primary" onClick={() => handleEdit(rowData)}>
              <FaEdit size={14} />
            </button>

            <button type="button" className="btn btn-sm btn-danger" onClick={() => handleDelete(rowData?.desg_id)}>
              <BiTrash size={14} />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="fac-topbar">
        <div className="fac-detnew">
          <h5 className="mb-0 mx-3">Designation Master</h5>
        </div>
      </div>

      <bie.Container fluid className="px-1">
        <bie.Container className="px-3 mw-100 pb-5">
          <FormikProvider value={designationFormik}>
            <Form id="service-form" className="newed-form">
              <bie.Row className="g-3">
                <bie.Col lg={4}>
                  <label className="form-label">Enter Designation Name</label>
                  <Field name="designationName" type="text" className="form-control" />
                  <ErrorMessage name="designationName" component="div" className="text-danger" />
                </bie.Col>

                <bie.Col lg={4}>
                  <button type="submit" className="btn btn-success btn-sm" style={{ marginTop: "34px" }}>
                    {serviceId ? "Update" : "Submit"}
                  </button>
                </bie.Col>
              </bie.Row>
              <br />

              {desigTableData?.length > 0 ? (
                <div className="table-responsive">
                  <CommonReactTable
                    data={desigTableData}
                    columns={desigTableColumns}
                    filename="Designation Report"
                    headerName="Designation Report"
                    showFooter={false}
                    showPagination={false}
                    showExcel={true}
                    showPrint={true}
                    excelFileName="Designation Details Report"
                  />
                </div>
              ) : (
                <center className="text-danger h5">**** No Data Found ****</center>
              )}
            </Form>
          </FormikProvider>
        </bie.Container>
      </bie.Container>
    </>
  );
}
